// extracted by mini-css-extract-plugin
export default {"button":"Cl-z","reviewSort":"Dl-z"};